import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import FeedbackMasterVotesFactory from '@/factory/feedback_master_votes'
import FeedbackServiceVotesFactory from '@/factory/feedback_service_votes'
import Vue from 'vue'

export default {
  state: {
    feedback: null,
    feedbackHistory: [],
    feedbacks: [],
    feedbackManagers: [],
    feedbackOrders: [],
    feedbackErrors: null,
    feedbackFilters: null,
    feedbackMasterVotes: new FeedbackMasterVotesFactory().create(),
    feedbackFilterStatus: Object.values(Vue.config.feedback_statuses),
    feedbackServiceVotes: new FeedbackServiceVotesFactory().create(),
    orderByHash: null,
  },
  getters: getters,
  mutations: mutations,
  actions: actions,
}
